const states = {
  agents: [],
  customers: [],
  Suppliers: [],
  stores: [],
};

export default states;
